import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './carousel-pagination-item.style.js'
import { classMap } from 'lit/directives/class-map.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


initializeIconsByRole({
  'cse-carousel-pagination.next':{ name: 'arrow-right', style: 'light' },
  'cse-carousel-pagination.previous':{ name: 'arrow-left', style: 'light' },
})

export const carouselPaginationTypes = ['dot', 'next', 'previous'] as const
export type carouselPaginationTypeTypes  = typeof carouselPaginationTypes

@customElement('cse-carousel-pagination-item')
export class CSECarouselPaginationItem extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style, fontStyles]

  @property({ type: Number })
  index = 0

  @property({ type: String })
  type: carouselPaginationTypeTypes[number]= 'dot'

  @property({ type: String })
  variant = 'primary'

  @property({ type: Boolean })
  selected = false

  @property({ type: Boolean })
  disabled = false

  override render() {
    if (this.type === 'dot') {
      return html `
        <button
          type="button"
          class="${classMap({
            'carousel-dot': true,
            'selected': this.selected,
            'disabled': this.disabled
          })}"
          ?disabled="${this.disabled}"
        >
        </button>
      `
    } else {
      return html `
        <cse-icon-button variant="${this.variant}" ?disabled="${this.disabled}">
          ${this.type === 'next'
            ? html`<cse-icon icon-role="cse-carousel-pagination.next" size="md"></cse-icon>`
            : html`<cse-icon icon-role="cse-carousel-pagination.previous" size="md"></cse-icon>`
          }
        </cse-icon-button>
      `
    }
  }
}
